import * as yup from 'yup'

export const validateCreateKits = yup.object().shape({
    name: yup
        .string()
        .required('Campo requerido.')
        .min(2, 'El NOMBRE debe tener más de 2 caracteres'),
    status: yup
        .string()
        .required('Campo requerido.')
        .oneOf(['active', 'inactive', 'pending security verification', 'pending user data', 'pending validation'], 'Debes elegir entre estas opciones'),
    audience: yup
        .string()
        .required('Campo requerido.')
        .oneOf(['estudiantes', 'comercial'], 'Debes elegir entre estudiantes o comercial'),
    price: yup
        .number()
        .typeError('Campo requerido.')
        .required('Campo requerido.')
        .min(0, 'El precio debe ser mayor o igual a 0'),
    description: yup
        .string()
        .nullable(),
    clase: yup
        .string()
        .nullable(),
    eyebrow: yup
        .string()
        .nullable(),
    ideal_for: yup
        .string()
        .nullable(),
    featured: yup
        .mixed()
        .nullable(),
    image: yup
        .string()
        .nullable(),
    priority: yup
        .number()
        .typeError('Campo requerido.')
        .nullable()
        .min(0, 'Debe de utilizar un numero que no sea negativo'),
})
